module.exports = __webpack_public_path__ + "media/components/shared/static/facebook-6313612be9569051989582d4d76c3d38.svg";